import { Termin } from '@/domain/arbeitszeiten/entities/Termin';
import { Arbeitsbereich } from './Arbeitsbereich';
import { BaseRow } from './BaseRow';
import { RowTypeMap } from './Entities';
import { Mitarbeiter } from './Mitarbeiter';
import { Rechtshinweis } from './Rechtshinweis';
import { Zeitstempel } from './Zeitstempel';
import { Zuschlag } from './Zuschlag';
import { ArbeitszeitArbeitszeitantragStatus } from '@/gql/graphql';
import { Pause } from '@/domain/arbeitszeiten/entities';

export class AntragZeitstempel {
  constructor({
    zeitstempel,
    changeRequested,
  }: {
    zeitstempel: Zeitstempel;
    changeRequested: boolean;
  }) {
    this.zeitstempel = zeitstempel;
    this.changeRequested = changeRequested;
  }
  readonly zeitstempel: Zeitstempel;
  readonly changeRequested: boolean;
}

type AntragConstructorProps = {
  mitarbeiter: Mitarbeiter;
  arbeitsbereich: Arbeitsbereich;
  beginn?: AntragZeitstempel;
  ende?: AntragZeitstempel;
  kommen?: AntragZeitstempel;
  gehen?: AntragZeitstempel;
  rechtshinweise?: Rechtshinweis[];
  zuschlaege?: Zuschlag[];
  termin?: Termin;
  bemerkung?: string;
  id: string;
  dauer?: number;
  pausen?: Pause[];
  offen?: boolean;
  status?: ArbeitszeitArbeitszeitantragStatus;
  bemerkungAntragsteller?: string;
  bemerkungVorgesetzter?: string;
  datum?: string;
  aenderungsdatum?: string;
  erstellungsdatum?: string;
  arbeitszeitId?: string;
};

export class Antrag extends BaseRow {
  readonly _type: keyof RowTypeMap = 'antrag';
  readonly mitarbeiter: Mitarbeiter;
  readonly arbeitsbereich: Arbeitsbereich;
  readonly beginn?: AntragZeitstempel;
  readonly ende?: AntragZeitstempel;
  readonly kommen?: AntragZeitstempel;
  readonly gehen?: AntragZeitstempel;
  readonly rechtshinweise: Rechtshinweis[];
  readonly zuschlaege: Zuschlag[];
  readonly termin?: Termin;
  readonly bemerkung?: string;
  readonly id: string;
  readonly dauer?: number;
  readonly pausen: Pause[];
  readonly offen?: boolean;
  readonly status?: ArbeitszeitArbeitszeitantragStatus;
  readonly bemerkungAntragsteller?: string;
  readonly bemerkungVorgesetzter?: string;
  readonly aenderungsdatum?: string;
  readonly erstellungsdatum?: string;
  readonly datum?: string;
  readonly arbeitszeitId?: string;

  constructor({
    mitarbeiter,
    arbeitsbereich,
    beginn = null,
    ende = null,
    kommen = null,
    gehen = null,
    rechtshinweise = [],
    zuschlaege = [],
    termin = null,
    bemerkung = '',
    id,
    dauer = 0,
    pausen = [],
    offen = false,
    status = null,
    bemerkungAntragsteller = '',
    bemerkungVorgesetzter = '',
    aenderungsdatum = null,
    erstellungsdatum = null,
    datum = null,
    arbeitszeitId = null,
  }: AntragConstructorProps) {
    super();
    this.mitarbeiter = mitarbeiter;
    this.arbeitsbereich = arbeitsbereich;
    this.beginn = beginn;
    this.ende = ende;
    this.kommen = kommen;
    this.gehen = gehen;
    this.rechtshinweise = rechtshinweise;
    this.zuschlaege = zuschlaege;
    this.termin = termin;
    this.bemerkung = bemerkung;
    this.id = id;
    this.dauer = dauer;
    this.pausen = pausen;
    this.offen = offen;
    this.status = status;
    this.bemerkungAntragsteller = bemerkungAntragsteller;
    this.bemerkungVorgesetzter = bemerkungVorgesetzter;
    this.aenderungsdatum = aenderungsdatum;
    this.erstellungsdatum = erstellungsdatum;
    this.datum = datum;
    this.arbeitszeitId = arbeitszeitId;
  }

  getPausendauer(): number {
    return this.pausen.reduce((total, pause) => total + pause.dauer, 0);
  }
}
